// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3WHzb","icon":"SortAdornment_icon__ERXSS","up":"SortAdornment_up__1LqVp","down":"SortAdornment_down__aK4tk","active":"SortAdornment_active__T0S6v"};